import LabelImportantIcon from '@material-ui/icons/LabelImportant';

const ListItemIcon = LabelImportantIcon;

export default ListItemIcon;